import React, { createContext, useContext, useState } from "react";
import AddProductToCartDialog from "./AddProductToCartDialog";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const AddProductToCartContext = createContext();

const NotAvailableButton = (props) => {
  const { t } = useTranslation();
  const { open, setOpen } = props;

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {t("Midlertidig utsolgt")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {t(
            "Produktet er midlertidig utsolgt. Velg gjerne noe annet fra menyen eller prøv igjen senere."
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)} autoFocus variant="outlined">
          {t("OK, tilbake til meny")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export const AddProductToCartProvider = ({ children }) => {
  const [activeProduct, setActiveProduct] = useState({});
  const [dialogOpen, setDialogOpen] = useState(false);

  const [qty, setQty] = useState(1);
  const [comment, setComment] = useState("");
  const [disabledDialogOpen, setDisabledDialogOpen] = useState(false);
  const [navigateDialogOpen, setNavigateDialogOpen] = useState(false);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [selectedAddonsQty, setSelectedAddonsQty] = useState({});

  const showAddToChartDialog = (product) => {
    if (product.disabled === "1") {
      setActiveProduct({});
      setDialogOpen(false);
      setDisabledDialogOpen(true);
    } else {
      setActiveProduct(product);
      setDialogOpen(true);
      setDisabledDialogOpen(false);
    }
    setQty(1);
    setComment("");
    setNavigateDialogOpen(false);
    setSelectedAddons([]);
    setSelectedAddonsQty({});
  };

  return (
    <AddProductToCartContext.Provider value={{ showAddToChartDialog }}>
      <NotAvailableButton
        open={disabledDialogOpen}
        setOpen={setDisabledDialogOpen}
      />
      <AddProductToCartDialog
        product={activeProduct}
        qty={qty}
        setQty={setQty}
        comment={comment}
        setComment={setComment}
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        navigateDialogOpen={navigateDialogOpen}
        setNavigateDialogOpen={setNavigateDialogOpen}
        selectedAddons={selectedAddons}
        setSelectedAddons={setSelectedAddons}
        selectedAddonsQty={selectedAddonsQty}
        setSelectedAddonsQty={setSelectedAddonsQty}
      />

      <>{children}</>
    </AddProductToCartContext.Provider>
  );
};

// Create a custom hook to use the context
export const useAddProductToCart = () => {
  const context = useContext(AddProductToCartContext);
  if (!context) {
    throw new Error("useFunction must be used within a AddProductToCart");
  }
  return context;
};
